module.exports = __webpack_public_path__ + "img/_DSC7979-min.c7a7bc63.jpg";